import { ClinicalDataList } from '#pages/ClinicalDataList';
import { PortfolioList } from '#pages/PortfolioList';
import { PortfolioLoad } from '#pages/PortfolioLoad';
import { Route, Routes } from 'react-router';
import { Portfolio } from 'src/refactor_page/portfolio/register';

export const PortfolioView = () => {
  return (
    <Routes>
      <Route path="/" element={<Portfolio />} />
      <Route path="/chartList" element={<ClinicalDataList type="selected" />} />
      <Route path="/list" element={<PortfolioList />} />
      <Route path="/load" element={<PortfolioLoad />} />
    </Routes>
  );
};
